module.exports = __webpack_public_path__ + "static/media/Connect.edae6162.svg";